import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "general" }
const _hoisted_2 = { class: "general__wrap" }
const _hoisted_3 = { class: "general__right-panel" }
const _hoisted_4 = { class: "general__keep-wrapper" }
const _hoisted_5 = { class: "search__text-suggest" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createVNode(_component_center, null, {
                default: _withCtx(() => [
                  _createTextVNode("Доступ запрещен.")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}